"use strict";

exports.__esModule = true;
exports.FARE_CALENDAR_PRICE_THRESHOLDS = exports.FARE_CALENDAR_PRICE_COLOR_MAP = void 0;
var FARE_CALENDAR_PRICE_COLOR_MAP = exports.FARE_CALENDAR_PRICE_COLOR_MAP = {
  GREEN: "green",
  YELLOW: "yellow",
  RED: "red"
};
var FARE_CALENDAR_PRICE_THRESHOLDS = exports.FARE_CALENDAR_PRICE_THRESHOLDS = {
  GREEN_PERCENTAGE: 20,
  YELLOW_PERCENTAGE: 50
};